/* eslint-disable no-param-reassign */
import React from 'react';
import { LaserBoard } from '@tencent/live-components';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { IPlayerState } from '../../common.interface';
import { ILiveManager } from '@src/slide/application/service/live-manager/core/interface';
interface IBoardSize {
    W: number;
    H: number;
}

interface IMouse {
    X: number;
    Y: number;
}

interface ILaserBoardContainerProps {
    playerState: IPlayerState;
    isMaster: boolean;
    liveManager: ILiveManager;
}

interface ILaserBoardContainerStates {
    showLaser: boolean;
}

class LaserBoardContainer extends React.Component<ILaserBoardContainerProps, ILaserBoardContainerStates> {
    private laserTimer: ReturnType<typeof setTimeout> | null;
    private currentPoint: { X: number; Y: number } = {
        X: -10,
        Y: -10,
    };
    private lastPen: { X: number; Y: number; p: number };
    public constructor(props: ILaserBoardContainerProps) {
        super(props);
        this.state = {
            showLaser: true,
        };
    }

    public shouldComponentUpdate(nextProps: ILaserBoardContainerProps) {
        const { isMaster, playerState } = this.props;
        return nextProps.isMaster !== isMaster || nextProps.playerState.laserTurnOn !== playerState.laserTurnOn;
    }

    public render() {
        const { playerState, isMaster, liveManager } = this.props;
        const masterLaser = (isMaster && playerState.laserTurnOn && !browser.isMobile);
        const laserOn = (masterLaser || !isMaster);
        return laserOn
            ? <LaserBoard
                liveDelegate={liveManager}
                onLaserBoardAnimate={this.onLaserBoardAnimate.bind(this)}>
            </LaserBoard>
            : null;
    }

    private onLaserBoardAnimate = (laserBoard: LaserBoard, param = {
        mouse: { X: -10, Y: -10 }, boardSize: { W: 0, H: 0 }, moved: false, visible: true,
    }) => {
        const { playerState, liveManager, isMaster } = this.props;
        const { scrollOffset = 0, scale } = playerState;
        const { showLaser } = this.state;
        showLaser ? laserBoard.show() : laserBoard.hide();
        const {
            mouse, boardSize, moved,
        } = { ...param };
        let { visible } = param;
        this.laserBoardNeedResize(boardSize, laserBoard);
        let points = mouse;
        this.needOnLaserPenMoved(moved, mouse, boardSize, playerState, liveManager);
        if (liveManager.isAudience) {
            // 将远程激光笔的数据管理交给liveManager，这里直接取数据；
            const pen = liveManager.getRemotePoint();
            const { isRemoteLaserOn } = liveManager;
            if (pen?.X) {
                this.lastPen = { ...pen };
            }
            if (this.lastPen) {
                // 客态翻页后，需要抛弃其他页上的激光笔；
                if (this.lastPen.p !== playerState.currentPage || !isRemoteLaserOn) {
                    laserBoard.hide();
                }
                this.currentPoint.X = (boardSize.W / 2) + (this.lastPen.X * scale);

                this.currentPoint.Y = (boardSize.H / 2) + (this.lastPen.Y * scale) + scrollOffset;
                pen && this.resetLaserTimer();
            } else {
                this.currentPoint.X = -10;
                this.currentPoint.Y = -10;
            }
            points = { ...this.currentPoint };
        } else {
            visible = true;
            points = mouse;
        }

        visible = true;
        if (isMaster) visible = false;
        return {
            visible,
            points,
        };
    };

    private laserBoardNeedResize(boardSize: IBoardSize, laserBoard) {
        if (boardSize && boardSize.W === 0 && boardSize.H === 0) {
            laserBoard.resize();
        }
    }

    private needOnLaserPenMoved(
        moved: boolean,
        mouse: IMouse,
        boardSize: IBoardSize,
        playerState: IPlayerState,
        liveManager: ILiveManager,
    ) {
        if (moved && mouse && boardSize) {
            // 发送激光笔数据
            const evt = {
                detail: {
                    ...mouse, ...boardSize, p: playerState.currentPage, f: playerState.currentFragment,
                },
            };
            liveManager.onLaserPenMoved(evt);
        }
    }

    private resetLaserTimer = () => {
        this.setState({ showLaser: true });
        if (this.laserTimer) {
            clearTimeout(this.laserTimer);
            this.laserTimer = null;
        }
        this.laserTimer = setTimeout(() => {
            this.setState({
                showLaser: false,
            });
            this.laserTimer = null;
        }, 3000);
    };
}

export default LaserBoardContainer;
